var map = {
	methods: {
		mapThumbSrc: function(width, height, type) {
			if (!width || !height) return 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
			type = type || 'map';
			return $url.encodeVar({
				size: width+","+height,
				center: win.mapConfig.lat+","+win.mapConfig.lng,
				zoom: win.mapConfig.zoom,
				type: type,
				imagetype: 'png',
				scalebar: false,
				lang: win.store.state.locale
			}, {
				url: win.mapConfig.thumbUrl
			});
		},
		showMap: function(type) { // search, city, poi, airport
			var mapPageParams = {
				fltLongitude: win.mapConfig.lat,
				fltLatitude: win.mapConfig.lng,
				intZoomLevel: win.mapConfig.zoom,
				strMapType: 'showHotelMap', // topCountries, topCities
				lang: 'en',
				imagetype: 'png',
				scalebar: false,
			};
			mapPageParams.strMapType = (typeof type === 'string') ? type : 'showHotelMap';
			mapPageParams.locale = win.store.state.locale;
			win.popup.show($url.encodeVar(mapPageParams, {
				url: win.mapConfig.pageUrl
			}));
		},
		showCountryMap: function() {
			this.showMap('topCities');
		},
		showHomeMap: function() {
			this.showMap('topCountries');
		},
		showHotelIdMap: function(hotelId) {
			win.popup.show($url.encodeVar({
				intHotelId: hotelId,
				lang: win.store.state.locale
			}, {
				url: win.mapConfig.pageUrl
			}));
		}
	}
};